<template>
    <div>
        <div
            v-if="readerType === 1"
            id="interactive"
            class="viewport scanner"
        ></div>
        <video
            v-if="readerType === 2"
            id="interactive"
            class="viewport-barcode-detector"
            autoplay
            playsinline
        ></video>
    </div>
</template>

<script>
    export default {
        name: 'scanner',
        data() {
            return {
                readerType: 0,
                barcodeDetector: null
            }
        },
        props: {
            onDetected: {
                type: Function
            },
            onProcessed: {
                type: Function
            }
        },

        mounted: function () {
            if ('BarcodeDetector' in window) {
                this.readerType = 2
                this.$nextTick(() => {
                    this.initBarcodeDetector()
                })
            } else {
                this.readerType = 1
                this.$nextTick(() => {
                    this.initHtml5Qrcode()
                })
            }
        },

        methods: {
            initBarcodeDetector() {
                BarcodeDetector.getSupportedFormats()
                    .then(supportedFormats => {
                        console.log('supportedFormats', supportedFormats)

                        this.barcodeDetector = new BarcodeDetector({
                            formats: supportedFormats
                        })
                        this.barcodeDetectorStartCamera()
                    })
            },

            async barcodeDetectorStartCamera() {
                try {
                    const devicesAll = await navigator.mediaDevices.enumerateDevices()
                    const devices = devicesAll.filter(device => device.kind === 'videoinput')

                    const ids = devices.map(item => item.deviceId)
                    const sel = this.$store.state.settings.camera
                    let deviceId = {facingMode: "environment"}    // prefer back camera
                    if (sel !== '' && ids.includes(sel)) {
                        deviceId = { deviceId: sel }
                    }

                    const video = document.getElementById('interactive')

                    // Request camera access and stream to video element
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: deviceId
                    });
                    video.srcObject = stream;
                    video.addEventListener('loadedmetadata', () => {
                        this.detectCodes();
                    });
                } catch (err) {
                    console.error('Error accessing camera:', err);
                    // resultDiv.textContent = `Error accessing camera: ${err.message}`;
                }
            },

            async detectCodes() {
                const video = document.getElementById('interactive')

                if (video.readyState === video.HAVE_ENOUGH_DATA) {
                    try {
                        // Detect barcodes in the video stream
                        const barcodes = await this.barcodeDetector.detect(video);

                        let bestBarcode = null
                        let bestBarcodeDistance = 1000

                        const videoCenter = {
                            x: video.videoWidth / 2,
                            y: video.videoHeight / 2
                        }

                        barcodes.forEach(barcode => {
                            let x = 0, y = 0
                            barcode.cornerPoints.forEach(point => {
                                x += point.x
                                y += point.y
                            })
                            x = x / barcode.cornerPoints.length
                            y = y / barcode.cornerPoints.length

                            const distance = Math.sqrt(
                                Math.pow(x - videoCenter.x, 2) +
                                Math.pow(y - videoCenter.y, 2)
                            )

                            if (distance < bestBarcodeDistance) {
                                bestBarcodeDistance = distance
                                bestBarcode = barcode
                            }
                        })

                        if (bestBarcode) {
                            this.onDetected(bestBarcode.rawValue)
                        }

                    } catch (err) {
                        console.error('Detection error:', err);
                        // resultDiv.textContent = `Detection error: ${err.message}`;
                    }
                }
                // Continue detection
                setTimeout(() => {
                    requestAnimationFrame(this.detectCodes);
                }, 200); // Adjust the delay time as needed (in milliseconds)
            },

            initHtml5Qrcode() {
                window.Html5Qrcode.getCameras().then(devices => {
                    const ids = devices.map(item => item.id)
                    const sel = this.$store.state.settings.camera
                    let deviceId = {facingMode: "environment"}    // prefer back camera
                    if (sel !== '' && ids.includes(sel)) {
                        deviceId = sel
                    }

                    this.reader = new window.Html5Qrcode("interactive");
                    this.reader.start(
                        deviceId, {
                            fps: this.$store.state.settings.frequency,    // Optional frame per seconds for qr code scanning
                            // Optional if you want bounded box UI
                            qrbox: document.body.clientWidth * this.$store.state.settings.patchSize / 100 * 0.6
                        },
                        qrCodeMessage => {
                            console.log('SUCCESS', qrCodeMessage)
                            this.onDetected(qrCodeMessage)
                        },
                        (/*errorMessage*/) => {
                            // parse error, ignore it.
                        })
                        .catch((/*err*/) => {
                            // Start failed, handle it.
                        });
                }).catch((/*err*/) => {
                    // handle err
                })
            },
        },

        beforeDestroy() {
            if (!('BarcodeDetector' in window)) {
                this.reader.stop()
            } else {
                // this.reader.stop()
            }
        },
    }
</script>

<style scoped>
    .viewport {
        display: inline-block;
        width: calc(60vw);
        margin: 0 auto;
    }
    .viewport-barcode-detector {
        display: inline-block;
        max-width: 100%;
        max-height: 40vh;
        margin: 0 auto;
    }
</style>
